import { readSessionStoredValue, removeSessionStoredValue, writeSessionStoredValue } from './storage';

export const conventionImportSessionKey = 'convention-import-draft';

export type ConventionImportDraft = {
  fileName: string;
  content: string;
  createdAt: number;
  source: 'conventions-list-dnd';
};

const isConventionImportDraft = (value: unknown): value is ConventionImportDraft => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.fileName === 'string' &&
    typeof candidate.content === 'string' &&
    typeof candidate.createdAt === 'number' &&
    candidate.source === 'conventions-list-dnd'
  );
};

export const saveConventionImportDraft = (draft: ConventionImportDraft): boolean => {
  try {
    return writeSessionStoredValue(conventionImportSessionKey, JSON.stringify(draft));
  } catch {
    return false;
  }
};

export const readConventionImportDraft = (): ConventionImportDraft | null => {
  try {
    // 저장소 차단 환경에서는 초안 없음으로 취급한다 (WEB-R).
    const raw = readSessionStoredValue(conventionImportSessionKey);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as unknown;
    if (!isConventionImportDraft(parsed)) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const clearConventionImportDraft = (): void => {
  removeSessionStoredValue(conventionImportSessionKey);
};
